import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Drawer, Button, Carousel, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { dateStringToEpoch, convertToEuro } from "../../../utils/utility";
import TicketCard from "./TicketCard";
import TicketCardTwoWay from "./TicketCardTwoWay";
import ticketActions from "../../../redux/ticket/actions";
import schedulesActions from "../../../redux/schedules/actions";
import ticketImage from "../../../images/ticket3.png";
import EmptyCart from "./EmptyCart";
import MyPos from "../MyPos";
import { decryptData } from "../../../utils/utility";
import "./index.css";
import { t } from "i18next";

const TicketsCheckoutDrawer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    addTicketsToCart,
    myposReservedTicket,
    cancelTicketReservation,
    setOpenCheckoutDrawer,
    setTicketsExpired,
  } = ticketActions;
  const { getSchedules, getSchedulesTwoWay } = schedulesActions;
  const { companies, token, showEuroPrice } = useSelector(
    (state) => state.mainReducer
  );
  const { openCheckoutDrawer, myposPaymentInformationLoading, ticketsExpired } =
    useSelector((state) => state.ticketReducer);
  const {
    destinationFrom,
    destinationTo,
    destinationDate,
    destinationDateTwoWay,
  } = useSelector((state) => state.destinationReducer);
  const [reservedTicketsWithExpiry, setReservedTicketsWithExpiry] = useState(
    []
  );
  const [timeRemaining, setTimeRemaining] = useState(null);

  const localStorageCart = decryptData(localStorage.getItem("cart")) || [];
  const localStorageReservedTickets =
    decryptData(localStorage.getItem("reservedTickets")) || [];

  const onCloseCheckoutDrawer = () => {
    dispatch(setOpenCheckoutDrawer(false));
    navigate(window.location.pathname.replace("/cart", ""));
  };

  const transformedReservTickets = localStorageReservedTickets.reduce(
    (acc, item) => {
      return [
        ...acc,
        ...(item.firstDirection ? [item.firstDirection] : []),
        ...(item.secondDirection ? [item.secondDirection] : []),
        ...(item.firstDirection || item.secondDirection ? [] : [item]),
      ];
    },
    []
  );

  const getTotalTicketsAmount = transformedReservTickets?.reduce(
    (accumulator, product) => {
      return accumulator + product.price;
    },
    0
  );

  const buyTicket = () => {
    dispatch(
      myposReservedTicket(
        token,
        companies[0]?.id,
        transformedReservTickets?.map((ticket) => ({
          article: ticket.namePrice,
          quantity: 1,
          price: ticket.price,
          amount: ticket.price,
          currency: 2,
          reserveId: ticket.id,
        })),
        "bg"
      )
    );
  };

  useEffect(() => {
    setReservedTicketsWithExpiry(localStorageReservedTickets || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(localStorageReservedTickets)]);

  useEffect(() => {
    const newArray = reservedTicketsWithExpiry.reduce((acc, item) => {
      return [
        ...acc,
        ...(item.firstDirection ? [item.firstDirection] : []),
        ...(item.secondDirection ? [item.secondDirection] : []),
        ...(item.firstDirection || item.secondDirection ? [] : [item]),
      ];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkExpirations = () => {
      const expirationTime = localStorage.getItem("ticketExpirationTime");
      if (expirationTime) {
        const remainingTime = expirationTime - new Date().getTime();
        if (remainingTime > 0) {
          setTimeRemaining(remainingTime);
        } else {
          setTimeRemaining(0);
          if (companies.length > 0) {
            newArray.forEach((ticket) => {
              dispatch(
                cancelTicketReservation(token, companies[0]?.id, ticket.id)
              );
            });

            setTimeout(() => {
              dispatch(
                getSchedules(
                  token,
                  companies[0]?.id,
                  destinationFrom,
                  destinationTo,
                  dateStringToEpoch(destinationDate.format("DD/MM/YYYY HH:mm"))
                )
              );
            }, 1000);

            setTimeout(() => {
              dispatch(
                getSchedulesTwoWay(
                  token,
                  companies[0]?.id,
                  destinationTo,
                  destinationFrom,
                  dateStringToEpoch(
                    destinationDateTwoWay.format("DD/MM/YYYY HH:mm")
                  )
                )
              );
            }, 1000);

            dispatch(setTicketsExpired(true));
            localStorage.removeItem("cart");
            dispatch(addTicketsToCart([]));
            localStorage.removeItem("reservedTickets");
            const event = new Event("cartUpdated");
            window.dispatchEvent(event);
            localStorage.removeItem("ticketExpirationTime");
            setReservedTicketsWithExpiry([]);
          }
        }
      }
    };

    const intervalId = setInterval(checkExpirations, 1000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservedTicketsWithExpiry, companies]);

  useEffect(() => {
    const handleRouteChange = () => {
      if (window.location.pathname.includes("/cart")) {
        dispatch(setOpenCheckoutDrawer(true));
      } else {
        dispatch(setOpenCheckoutDrawer(false));
      }
    };

    handleRouteChange();

    window.addEventListener("popstate", handleRouteChange);
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatTimeRemaining = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <>
      <MyPos />
      <Drawer
        styles={{
          body: {
            padding: window.innerWidth > 760 ? "20px" : "10px",
            paddingBottom: "20px",
          },
        }}
        width={window.innerWidth > 760 ? "450px" : "100%"}
        title={`${t("tickets")} (${localStorageCart.length})`}
        onClose={onCloseCheckoutDrawer}
        open={openCheckoutDrawer}
        footer={
          localStorageCart.length > 0 ? (
            <>
              <Button
                disabled={
                  myposPaymentInformationLoading ||
                  ticketsExpired ||
                  getTotalTicketsAmount === 0
                }
                className={` ticket-drawer-pay-button ${
                  getTotalTicketsAmount === 0
                    ? "disabled-pay-button"
                    : "custom-button"
                }`}
                loading={myposPaymentInformationLoading}
                size="large"
                type="primary"
                onClick={() =>
                  getTotalTicketsAmount > 0 &&
                  !myposPaymentInformationLoading &&
                  buyTicket()
                }
              >
                {showEuroPrice ? (
                  <>
                    {t("payment")} {getTotalTicketsAmount?.toFixed(2)} € /{" "}
                    {convertToEuro(getTotalTicketsAmount)?.toFixed(2)} {t("lv")}
                  </>
                ) : (
                  `${t("payment")} ${getTotalTicketsAmount?.toFixed(2)} €`
                )}
              </Button>
            </>
          ) : (
            <Button
              className="custom-button ticket-drawer-pay-button"
              size="large"
              type="primary"
              onClick={onCloseCheckoutDrawer}
            >
              {t("back")}
            </Button>
          )
        }
      >
        {localStorageCart.length > 0 ? (
          <>
            <Carousel className="tickets-card-carousel" draggable>
              <div>
                <div className="carousel-card">
                  <div className="carousel-card-image">
                    <img src={ticketImage} alt="CardImage1" />
                  </div>
                  <div className="carousel-card-content">
                    <h2>{t("notice")}</h2>
                    <p>{t("afterSuccessTicketBuy")}</p>
                  </div>
                </div>
              </div>
            </Carousel>
            <Alert
              description={`${t("ticketsWillExpire")} ${formatTimeRemaining(
                timeRemaining
              )} ${t("minutes")}`}
              showIcon
              style={{ marginBottom: "20px" }}
            />
            {localStorageCart?.map((ticket, index) =>
              Object.prototype.hasOwnProperty.call(ticket, "firstDirection") ? (
                <TicketCardTwoWay key={index} ticket={ticket} index={index} />
              ) : (
                <TicketCard key={index} ticket={ticket} index={index} />
              )
            )}
          </>
        ) : (
          <>
            <EmptyCart />
            {ticketsExpired && (
              <Alert
                description={t("expireTicketsInCart")}
                type="error"
                showIcon
              />
            )}
          </>
        )}
      </Drawer>
    </>
  );
};

export default TicketsCheckoutDrawer;
